module.exports = __webpack_public_path__ + "static/media/testTeam.0e72c493.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/testTeam.gif
// module id = 1125
// module chunks = 4